import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { messages } from '../../constants/Collection';
import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import { formatTime } from '../../lib/TimeUtils';

import CatalogGridItem from './CatalogGridItem';

/**
 * TrackGridItem is for rendering T3 track grid items.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class TrackGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    isPlayingCurrently: PropTypes.bool,
    isMixedWithOtherSources: PropTypes.bool,
    isCurrentPlaylist: PropTypes.bool,
    isPaused: PropTypes.bool,
    sourceCardMenuItems: PropTypes.array,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    itemOnclickUrl: PropTypes.string,
    secondText: PropTypes.string,
    duration: PropTypes.number,
    intl: PropTypes.object,
    componentName: PropTypes.string,
  };

  render() {
    return (
      <CatalogGridItem
        thirdText={this.props.intl.formatMessage(messages.songThirdText, {
          duration: formatTime(this.props.duration),
        })}
        {...this.props}
        forceRestartSourceIfPlaying={
          this.props.isMixedWithOtherSources && !this.props.isCurrentPlaylist
        }
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const id = ownProps.id;
  const details = getAnnotationsById(state, id);
  props.blankItem = !details;
  if (details && id) {
    props.isCurrentPlaylist = getInDomain('playback.utils.getCurrentPlaylist', noop)(state) === id;
    props.isPlayingCurrently = getInDomain('playback.utils.isTrackPlayingCurrently', false)(
      state,
      id,
    );
    props.isPlayingCurrently = ownProps.isMixedWithOtherSources
      ? props.isPlayingCurrently && props.isCurrentPlaylist
      : props.isPlayingCurrently;
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: id,
      pandoraType: PandoraTypes.SONG,
      shareParentSource: {
        shareParentSourceId: details.get('albumId'),
        shareParentSourceType: PandoraTypes.ALBUM,
      },
      albumId: details.get('albumId'),
      componentName: ownProps.componentName,
    });
    const backstageUrl = details.get('shareableUrlPath');
    props.mainTextUrl = backstageUrl;
    props.itemOnclickUrl = backstageUrl;
    props.mainText = details.get('name');
    props.secondText = details.get('artistName');
    props.duration = details.get('duration');
    const artist = getAnnotationsById(state, details.get('artistId'));
    if (artist) {
      props.secondTextUrl = artist.get('shareableUrlPath');
    }
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = getInDomain('catalog.utils.isClean')(details);
    props.dominantColor = getDominantColor(details);
  }
  return props;
}

// We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
export default injectIntl(connect(mapStateToProps, {})(TrackGridItem));
